<section class="section">


<div class="row" >


	<div class="col-12 col-sm-6 col-xl-6" >
		<article class="article">

		<div class="card-header">
		<h2 style="margin: 0px;">Account Summary</h2>
		</div>

		<div class="article-details" style="line-height: 3.0;">
			

			<div class="row row-align">
				<div class="col-6 col-sm-5">
					Account Number
				</div>
				<div class="col-3 col-sm-4 bold-fonts">
					{{callbalances.server_name1}}
					
				</div>
				<div class="col-3 col-sm-3">
					<!-- <span class="btn btn-primary pointer" (click)="readmores(l.mrvoip_other_service_id)">Add Credits</span> -->
				</div>
			</div>
			<div class="row row-align">
				<div class="col-6 col-sm-5">
					Current Account Balance
				</div> 
				<div class="col-3 col-sm-4 bold-fonts">
					{{callbalances.main_balance_pbx1}}
				</div>
				<div class="col-3 col-sm-3">
					<span class="btn btn-primary pointer" (click)="addCreditsModal()">Add Credits</span>
				</div>
			</div>
			<div class="row row-align">
				<div class="col-6 col-sm-5">
					Minimum Account Balance
				</div>
				<div class="col-3 col-sm-4 bold-fonts">
					<span *ngIf="showInput == false">
						{{callbalances.threshold_limit1}}
					</span>
					<input *ngIf="showInput == true" class="form-control mt-2" type="text" [(ngModel)]="minThrehold" >
				</div>
				<div class="col-3 col-sm-3">
					<span  *ngIf="showInput == false" class="btn btn-primary pointer" (click)="editMinimum()">Edit</span>
					<span *ngIf="showInput == true" class="btn btn-success pointer" (click)="submitThrehold()" title="Submit"><i class="fa fa-check" aria-hidden="true"></i></span>
					<span *ngIf="showInput == true" class="btn btn-danger pointer ml-2" (click)="cancelSubmitThrehold()" title="Cancel"><i class="fa fa-close" aria-hidden="true"></i></span>
				</div>
			</div>
			
			
		</div>
		</article>
		</div>

</div>

</section>


<div class="modal fade createticketModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
aria-hidden="true"  id="addcredits">
<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="myLargeModalLabel">Add Credit Amount</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

    

      <form class="deal-register-form" [formGroup]="addcredits">

        <div class="form-group">
          <label for="partner-name">Customer Name</label>
            <input type="text" class="form-control" id="partner-name" formControlName="customername" readonly >
              <div class="error-message message-small" *ngIf="!addcredits.get('customername').valid && addcredits.get('customername').touched">
                     
          </div>
      </div>

	  
	  <div class="form-group">
		<label for="topupvalue">Top Up Amount</label>

		<select id="topupvalue" name="topupvalue" class="optional form-control" formControlName="topupvalue">
		  <!-- <option value="" selected="selected">Please Select Topup Amount</option> -->
		  <!-- <option value="{{item.id}}" *ngFor="let item of countrylist">{{item.country}}</option> -->
		  <option value="50">$50</option>
		  <option value="100" >$100</option>
		  <option value="200" >$200</option>
		  <option value="250" >$250</option>
		  <option value="500" >$500</option>
		  <option value="1000" >$1000</option>
		</select>
		<div class="error-message message-small"
		  *ngIf="!addcredits.get('topupvalue').valid && addcredits.get('topupvalue').touched">
		  Please Choose a Topup Amount
		</div>
	  </div>
                 
        <div class="btn-groups aligncenter">
          <a  class="btn btn-success mr-3" (click)="paymentCredits()">Submit</a>
          <a  class="btn btn-info" data-dismiss="modal">Cancel</a>
        </div>
      </form>
    </div>
  </div>
</div>
</div> 
